(function () {
  function applyPreselectedVariant(el) {
    var preselectedId = parseInt(el.dataset.preselectedVariant, 10);
    if (!preselectedId) return;

    var checkedInput = el.querySelector('input[type="radio"]:checked');
    if (!checkedInput) return;

    checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Use 'load' (not DOMContentLoaded) so main.js has fully run and
  // registered + initialised the variant-selects custom element.
  // 300ms timeout gives connectedCallback async work time to settle.
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('variant-selects[data-preselected-variant]').forEach(function (el) {
        applyPreselectedVariant(el);
      });
    }, 300);
  });

  // Shopify customizer — fires when a section is re-rendered after a setting change
  function runAll() {
    setTimeout(function () {
      document.querySelectorAll('variant-selects[data-preselected-variant]').forEach(function (el) {
        applyPreselectedVariant(el);
      });
    }, 500);
  }

  document.addEventListener('shopify:section:load', runAll);
  document.addEventListener('shopify:section:select', runAll);
  document.addEventListener('shopify:block:select', runAll);
})();